import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 83 83"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#8AB844",
      d: "M70.777 12.143a41.46 41.46 0 1 0-58.633 58.633 41.46 41.46 0 0 0 58.633-58.633ZM41.46 77.363c-19.797 0-35.903-16.106-35.903-35.903 0-19.797 16.106-35.903 35.903-35.903 19.797 0 35.903 16.106 35.903 35.903 0 19.797-16.106 35.903-35.903 35.903Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#8AB844",
      d: "M35.209 50.153 22.46 37.405l-3.929 3.929L35.21 58.01l29.087-29.086-3.93-3.93L35.21 50.153Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "success"}) } }